export default {"src":"/_next/static/media/commercial-icon-selected.8497c413.svg","height":95,"width":75,"blurWidth":0,"blurHeight":0};